import { render, staticRenderFns } from "./IngredientSearch.vue?vue&type=template&id=7858dea8&scoped=true"
import script from "./IngredientSearch.vue?vue&type=script&lang=js"
export * from "./IngredientSearch.vue?vue&type=script&lang=js"
import style0 from "./IngredientSearch.vue?vue&type=style&index=0&id=7858dea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7858dea8",
  null
  
)

export default component.exports